export default __webpack_public_path__ + "9c9140628171bf33ad87c572d1f454e4.png";